module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-dune-abstract-kimberly-0.a203de27.jpg";